var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 511,
    viewBox: "0 0 397 511",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.907,
    width: 41.093,
    height: 41.093,
    rx: 6,
    fill: "url(#paint0_linear_2_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.5,
    y: 21.4072,
    width: 40.093,
    height: 40.093,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 132.686,
    width: 30.814,
    height: 30.814,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.5,
    y: 158.5,
    width: 30.814,
    height: 30.814,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.5,
    y: 340.5,
    width: 30.814,
    height: 30.814,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.186,
    width: 31.814,
    height: 31.814,
    rx: 6,
    fill: "url(#paint1_linear_2_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 16.6855,
    width: 30.814,
    height: 30.814,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.2325,
    y: 378,
    width: 39.7675,
    height: 39.7675,
    rx: 6,
    fill: "url(#paint2_linear_2_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 398.732,
    width: 38.7675,
    height: 38.7675,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.861,
    y: 461,
    width: 33.1395,
    height: 33.1395,
    rx: 6,
    fill: "url(#paint3_linear_2_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.5,
    y: 478.359,
    width: 32.1395,
    height: 32.1395,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2",
    x1: 288.023,
    y1: 43.9767,
    x2: 334.883,
    y2: -9.12423e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_2",
    x1: 94.9534,
    y1: 34.0465,
    x2: 131.233,
    y2: -7.06392e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_2",
    x1: 69.4418,
    y1: 420.558,
    x2: 114.791,
    y2: 378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_2",
    x1: 329.535,
    y1: 496.465,
    x2: 367.326,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396.81,
    height: 511,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.92c20a9b7ced00e78f7de14949b8127d.svg";
export { ForwardRef as ReactComponent };